import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import DisclosureCounselingRepository from '@/repositories/disclosureCounselingRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import { DscsvclstResponce } from '@/models/disclosureCounseling/disclosureCounselingModel';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useDisclosureCounselingReserveStore = defineStore({
    id: 'disclosureCounselingReserve',
    state: () => ({
        ServiceList: [],
        SelectServiceList: [],
    }),
    getters: {},
    actions: {
        /**
         * 開示カウンセリングサービス一覧取得API
         * @param {String} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getServiceListAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const disclosureCounselingRepository = new DisclosureCounselingRepository();

            try {
                const response = await disclosureCounselingRepository.getDisclosureCounselingServiceListApi(API_URL, requestBody, idToken);

                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }

                this.ServiceList = response.data.List;
                this.SelectServiceList = response.data.List.map((item) => DscsvclstResponce.formApiResponse(item));
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 開示カウンセリング登録API
         * @param {String} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async registDisclosureCounselingAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const disclosureCounselingRepository = new DisclosureCounselingRepository();

            try {
                const response = await disclosureCounselingRepository.registDisclosureCounselingApi(API_URL, requestBody, idToken);

                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }

                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        reset() {
            this.ServiceList = [];
            this.SelectServiceList = [];
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
